import React from 'react';
import './About.css';

const features = [
  { icon: '✅', text: '500+ Trained Workers' },
  { icon: '🏗️', text: 'Chakan MIDC Experts' },
  { icon: '📋', text: 'Labour Law Compliant' },
  { icon: '⚡', text: 'Fast Deployment' },
  { icon: '🧹', text: 'Housekeeping Pros' },
  { icon: '🔒', text: 'PF & ESI Managed' },
];

// HD Pexels image — industrial supervisor/manager with workers on factory floor
const ABOUT_IMG = 'https://images.pexels.com/photos/3184418/pexels-photo-3184418.jpeg?auto=compress&cs=tinysrgb&w=900&h=700&fit=crop';

const About = () => (
  <section className="about section-light" id="about">
    <div className="container about-grid">

      {/* LEFT — image block */}
      <div className="about-visual">
        <div className="about-img-wrap">
          <img
            src={ABOUT_IMG}
            alt="SSM Services industrial workforce team"
            className="about-img"
            loading="lazy"
          />
          {/* Floating badge over image */}
          <div className="about-badge">
            <div className="big">9+</div>
            <div className="sm">Years of Trust</div>
          </div>
          {/* Decorative border accent */}
          <div className="about-img-border" />
        </div>
      </div>

      {/* RIGHT — text */}
      <div className="about-body">
        <span className="section-label">About SSM Services</span>
        <h2 className="section-title">
         Chakan's Most Trusted<br />
          <span>Manpower Partner</span>
        </h2>
        <div className="divider" />
        <p className="about-para">
          Shri Sai Manpower Services has been a cornerstone of industrial workforce
          solutions since 2017. Headquartered in Chakan, Pune, we deliver
          skilled, semi-skilled, and unskilled manpower to leading manufacturers
          across Maharashtra's industrial corridors.
        </p>
        <p className="about-para">
          With 500+ trained employees and deep roots in Chakan MIDC, Talegaon MIDC,
          and Bhosari MIDC, we understand the pace, compliance needs, and operational
          demands of modern industry.
        </p>
        <div className="about-features">
          {features.map((f) => (
            <div className="feat-item" key={f.text}>
              <div className="feat-icon">{f.icon}</div>
              <div className="feat-text">{f.text}</div>
            </div>
          ))}
        </div>
      </div>

    </div>
  </section>
);

export default About;
